export default __webpack_public_path__ + "static/media/FG_41.d6491141.png";